import axios from "axios";
import type { AxiosHeaderValue, AxiosResponse, InternalAxiosRequestConfig } from "axios";
import { apiConfig, graphConfig } from "config/app-config";
import networkService from "./networkService";

function getConfigWithHeaders(
  scopes: Array<string>,
  additionalHeaders?: Record<string, AxiosHeaderValue | undefined>
): (config: InternalAxiosRequestConfig<unknown>) => Promise<InternalAxiosRequestConfig<unknown>> {
  return async (config: InternalAxiosRequestConfig<unknown>) => {
    const headers = { ...(await networkService.createHeaders(scopes)), ...additionalHeaders };
    Object.entries(headers).forEach(([name, value]) => {
      config.headers.set(name, value);
    });
    return config;
  };
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function getResponseData(response: AxiosResponse<any, any>): any {
  return response?.data?.data ?? response?.data ?? response;
}

// API Collectivités
const { scopes: collectivitesScope, apiName: collectivitesApiName } = apiConfig.collectivitesApi;
const collectivitesApiClient = axios.create({
  baseURL: `${apiConfig.apimBaseUrl}/${collectivitesApiName}`,
  // baseURL: "http://localhost:7108/api",
});
collectivitesApiClient.interceptors.request.use(getConfigWithHeaders(collectivitesScope));
collectivitesApiClient.interceptors.response.use(getResponseData);

// API Contacts Métiers
const { scopes: cometApiScope, apiName: cometApiName } = apiConfig.cometApi;
const cometApiClient = axios.create({
  baseURL: `${apiConfig.apimBaseUrl}/${cometApiName}`,
  // baseURL: "http://localhost:7108/api",
});
cometApiClient.interceptors.request.use(getConfigWithHeaders(cometApiScope));
cometApiClient.interceptors.response.use(getResponseData);
/**
 * Client Comet spécifique sans les intercepteurs des réponses afin d'accéder à la réponse Axios brute.
 */
const cometApiRawClient = axios.create({
  baseURL: `${apiConfig.apimBaseUrl}/${cometApiName}`,
  // baseURL: "http://localhost:7108/api",
});
cometApiRawClient.interceptors.request.use(getConfigWithHeaders(cometApiScope));

// API Graph
const graphApiName = graphConfig.graphEndpoint;
const graphApiScopes = apiConfig.azureAd.scopes;
const graphApiClient = axios.create({ baseURL: graphApiName });
graphApiClient.interceptors.request.use(
  getConfigWithHeaders(graphApiScopes, { ConsistencyLevel: "eventual" })
);

export { collectivitesApiClient, cometApiClient, cometApiRawClient, graphApiClient };
